import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuPopover = styled(Popover)(() => ({
    '& .MuiPopover-paper': {
        boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 6px 10px -3px rgba(0, 0, 0, 0.14)',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        '& .MuiBox-root': {
            position: 'relative',
            '& button': {
                '& .MuiTypography-root': {
                    fontSize: '1rem',
                },
            },
            '& ul': {
                backgroundColor: 'var(--nav-popover-bg)',
                '& .MuiButtonBase-root': {
                    padding: '.75rem 1.25rem',
                },
            },
            '& .MuiTypography-root': {
                fontFamily: 'var(--nav-font-family)',
                color: 'var(--nav-text-color)',
            },
        },
        '& .reportPicker': {
            '& .categoryContainer': {
                width: '200px',
            },
        },
    },
}));
